export const ADMIN = 'ADMIN'
export const MANAGER = 'MANAGER'
export const SERVER = 'SERVER'